import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "Department";

export const getDepartmentDetailsUrl = (departmentId) =>
	`${baseUrl}/${departmentId}`;
export const getDepartmentsUrl = (studentTypeId, facultyId, isApplication) =>
	`${baseUrl}/${studentTypeId}${
		facultyId ? `/${facultyId}` : ""
	}/departments${isApplication ? `?application=${isApplication}` : ""}`;
export const getAllDepartmentsUrl = (facultyId) =>
	`${baseUrl}/all-departments?facultyId=${facultyId}`;
export const getDepartmentOptionUrl = ({ departmentId, studentTypeId }) =>
	`${baseUrl}${
		studentTypeId ? `/${studentTypeId}` : ""
	}/${departmentId}/departmentoptions`;
export const getApplicationDepartmentsUrl = (filter) =>
	`${baseUrl}/application-departments?${generateUrlParams(filter)}`;
export const getAllHODsUrl = (filter) =>
	`${baseUrl}/hods?${generateUrlParams(filter)}`;
export const assignHODToDepartmentUrl = () =>
	`${baseUrl}/assign-hod-to-department`;
export const jupebCourseOptionsUrl = () => `${baseUrl}/jupeb-options`;
export const jupebCourseOptionsSubjectUrl = (jupebOptionsId) =>
	`${baseUrl}/${jupebOptionsId}/jupeb-options-subjects`;
export const getLecturerDepartmentsUrl = (filter) =>
	`${baseUrl}/departments-for-result-approval?${generateUrlParams(filter)}`;
export const getDepartmentJupebOptionsUrl = () => `${baseUrl}/jupeb-options`;
export const getDepartmentJupebOptionsSubjects = (jupebOptionsId) =>
	`${baseUrl}/${jupebOptionsId}/jupeb-options-subjects`;
export const getAllDepartmentActiveSessionsUrl = (filter) =>
	`${baseUrl}/get-all-depts-active-sessions?${generateUrlParams(filter)}`;
export const rollbackDepartmentActiveSessionUrl = () =>
	`${baseUrl}/rollback-active-session`;
export const setDepartmentActiveSessionUrl = () =>
	`${baseUrl}/set-active-session`;
export const getLevelCourseAdvisersUrl = (filter) =>
	`${baseUrl}/get-department-level-course-advisers?${generateUrlParams(
		filter
	)}`;
export const assignLevelCourseAdvisersUrl = () =>
	`${baseUrl}/assign-level-course-adviser`;

export const canStudentUpdateDepratmentOptionUrl = () =>
	`${baseUrl}/can-student-update-department-option`;
export const assignDepartmentProgramme = () =>
	`${baseUrl}/assign-department-programme`;
export const bulkDepartmentsUploadUrl = () => `${baseUrl}/upload-departments`;
export const bulkOptionsUploadUrl = () => `${baseUrl}/upload-options`;
export const createDepartmentUrl = () => `${baseUrl}/create-department`;
export const createOptionUrl = () => `${baseUrl}/create-option`;
export const deleteOptionUrl = (id) =>
	`${baseUrl}/delete-department-option?optionId=${id}`;
export const deleteDepartmentUrl = (id) =>
	`${baseUrl}/delete-department?departmentId=${id}`;
export const downloadDepartmentExcelTemplateUrl = () =>
	`${baseUrl}/download-department-upload-template`;
export const downloadOptionExcelTemplateUrl = () =>
	`${baseUrl}/download-department-upload-template`;
export const getAllAvailableDepartmentsUrl = () =>
	`${baseUrl}/all-available-departments`;
export const getAllPaginatedDepartmentsUrl = (filter) =>
	`${baseUrl}/get-paginated-departments?${generateUrlParams(filter)}`;
export const getAllPaginatedOptionsUrl = (filter) =>
	`${baseUrl}/get-paginated-departments-options?${generateUrlParams(filter)}`;
export const getDepartmentsAreaOfSpecializationUrl = (filter) =>
	`${baseUrl}/get-departments-programmes-area-of-specialization?${generateUrlParams(
		filter
	)}`;
export const getProgrammeDepartmentsUrl = (programId) =>
	`${baseUrl}/get-programme-departments?programId=${programId}`;
export const toggleDepartmentActivationStatusUrl = (id) =>
	`${baseUrl}/toggle-department-activation?departmentId=${id}`;
export const toggleOptionActivationStatusUrl = (id) =>
	`${baseUrl}/toggle-option-activation?optionId=${id}`;
export const updateDepartmentUrl = () => `${baseUrl}/update-department`;
export const updateOptionUrl = () => `${baseUrl}/update-department-option`;
